import React, { useCallback, useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import {
  DataGrid,
  GridColDef,
  GridSelectionModel,
  GridSortModel,
} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { PaginationFooter } from "../GridPagination/index.tsx";
import styles from "./index.module.scss";
// import sortAsc from "../../../assets/images/sort-asc.svg";
// import sortDesc from "../../../assets/images/sort-desc.svg";

interface DataGridWithPaginationProps {
  headers: GridColDef[];
  programsData?: unknown[];
  hoverImageClass?: string;
  totalData?: number;
  pageSize?: number;
  setPageSize?: (size: number) => void;
  currentPage?: number;
  setCurrentPage?: (page: number) => void;
  loading?: boolean;
  height?: string;
  onRowClick?: (rowData: unknown) => void;
  withoutStartAt?: boolean;
  isheight?: boolean;


}

const DataGridWithPagination: React.FC<DataGridWithPaginationProps> = ({
  headers,
  programsData = [],
  hoverImageClass,
  totalData = 0,
  pageSize = 10,
  setPageSize,
  currentPage = 1,

  setCurrentPage,
  loading = false,
  height = "calc(100vh - 0px)",
  onRowClick,
  withoutStartAt,
  isheight,
}) => {
  console.log(programsData, "programsData", headers, totalData);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [dataToShow, setDataToShow] = useState<unknown[]>([]);
  const [sortModel, setSortModel] = useState<GridSortModel>([]);

  // Ensure we have valid data arrays
  const validProgramsData = Array.isArray(programsData) ? programsData : [];
  const validHeaders = Array.isArray(headers) ? headers : [];
  {console.log(validHeaders, "validHeaders")}

  const columns: GridColDef[] = validHeaders.map(
    (column: GridColDef, index: number) => ({
      ...column,
      sortable: column.sortable !== undefined ? column.sortable : false,
      headerClassName: "sortable-header",
    })
  );

  const loadMoreData = useCallback(() => {
    setDataToShow(validProgramsData);
    console.log("Data to show updated:", validProgramsData);
  }, [validProgramsData]);


  useEffect(() => {
    loadMoreData();
  }, [loadMoreData]);

  const handleSelectionChange = (newSelection: GridSelectionModel) => {
    setSelectedRows(newSelection.map(Number));
  };

  const handlePageChange = (page: number) => {
    if (setCurrentPage) {
      setCurrentPage(page);
    }
  };

  const handlePageSizeChange = (size: number) => {
    if (setPageSize) {
      setPageSize(size);
    }
    if (setCurrentPage) {
      setCurrentPage(1);
    }
  };

  const handleSortModelChange = (model: GridSortModel) => {
    setSortModel(model);

    if (model.length > 0 && validProgramsData.length > 0) {
      const { field, sort } = model[0];

      const sortedData = [...validProgramsData].sort(
        (a: unknown, b: unknown) => {
          const aValue = a?.[field];
          const bValue = b?.[field];

          if (aValue === undefined || aValue === null) return 1;
          if (bValue === undefined || bValue === null) return -1;

          if (sort === "asc") {
            return aValue > bValue ? 1 : -1;
          } else if (sort === "desc") {
            return aValue < bValue ? 1 : -1;
          }
          return 0;
        },
      );

      const startIndex = (currentPage - 1) * pageSize;
      const newData = sortedData.slice(startIndex, startIndex + pageSize);
      setDataToShow(newData);
    }
  };

  const getItemsPerPageOptions = () => {
    return [10, 50, 100];
  };

  console.log("Rendering DataGrid with:", {
    dataToShowLength: dataToShow.length,
    columnsLength: columns.length,
    loading,
  });

  // Don't render DataGrid if no columns are available
  if (!loading && columns.length === 0) {
    return (
      <div className={styles.programListDashboard}>
        <Box className={styles.container}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: height,
              border: "1px solid #e0e0e0",
              borderRadius: "4px",
            }}
          >
            No data available
          </Box>
        </Box>
      </div>
    );
  }

  return (
    <div
      className={styles.programListDashboard}
      data-testid="program-list-dashboard"
    >
      <div>
        <Box className={styles.container} data-testid="box-container">
          <DataGrid
            sx={{
              rowWidth: "calc(100% - 80px)",
              "&.MuiDataGrid-root": {
                borderLeft: "none",
                borderRight: "none",
                height: isheight ? "calc(100vh - 350px)" : "calc(100vh - 180px)",
                overflow: "unset",
              },
              "& .MuiDataGrid-scrollbar--vertical ": {
                maxWidth: "5px",
              },
              "& .MuiDataGrid-scrollbar--horizontal ": {
                maxHeight: "100%",
                display: "block",
              },
              "& .MuiDataGrid-columnSeparator": {
                display: "none",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "400",
                fontSize: "14px",
                color: "#051B46",
              },
              "& .MuiDataGrid-columnHeaderTitle:focus": {
                outline: "none",
              },
              "& .MuiDataGrid-sortIcon": {
                opacity: "1 !important",
                color: "#051B46",
              },
              "& .MuiDataGrid-columnHeader:not([aria-sort])": {
                "& .MuiDataGrid-sortIcon": {
                  opacity: "1 !important",
                  color: "#CCCCCC",
                },
              },
              "& .MuiDataGrid-row": {
                cursor: "pointer",
                [`&:hover .${hoverImageClass}`]: {
                  display: "block",
                },
              },
              ".MuiDataGrid-row": {
                cursor: "pointer",
              },
              ".MuiDataGrid-columnHeader": {
                border: "none",
                borderColor: "none",
                padding: "10px",
                cursor: "default",
              },
              ".MuiDataGrid-cell": {
                padding: "10px",
                color: "#051B46",
                display: "flex",
                alignItems: "center",
              },
              ".MuiDataGrid-cell:focus": {
                outline: "none",
              },
              "& .MuiDataGrid-cellCheckbox:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus-within,": {
                outline: "none",
              },
              "& .MuiCheckbox-root": {
                color: "transparent",
              },
              "& .MuiCheckbox-root svg": {
                fill: "grey",
              },
              "& .Mui Checkbox-root.Mui-checked svg": {
                fill: "#1859B4",
              },
              "& .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#F4F8FB",
              },
              "& .MuiDataGrid-cell--textLeft": {
                lineHeight: "20px",
              },
            }}
            rows={dataToShow}
            getRowId={(row) =>
              row?.id || row?.registrationId || row?.email || Math.random()
            }
            onRowClick={(params) => {
              if (onRowClick) {
                onRowClick(params.row);
              }
            }}
            columns={headers}
            paginationMode="server"
            sortingMode="client"
            rowCount={totalData}
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange}
            page={currentPage - 1}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: pageSize,
                  page: currentPage - 1,
                },
              },
              sorting: {
                sortModel: [
                  // {
                  //   field: headers[0]?.field || "id",
                  //   sort: "desc",
                  // },
                ],
              },
            }}
            sortModel={sortModel}
            onSortModelChange={handleSortModelChange}
            sortingOrder={["desc", "asc"]}
            disableColumnReorder
            disableMultiSort
            slots={{
              columnSortedDescendingIcon: () => (
                // <img
                //   src={sortDesc}
                //   alt="Sort Descending"
                //   style={{ width: "16px", height: "16px" }}
                // />
                <></>
              ),
              columnSortedAscendingIcon: () => (
                // <img
                //   src={sortAsc}
                //   alt="Sort Ascending"
                //   style={{ width: "16px", height: "16px" }}
                // />
                <></>

              ),
              footer: () => (
                <PaginationFooter
                  currentPage={currentPage}
                  pageSize={pageSize}
                  total={totalData}
                  itemsPerPageOptions={getItemsPerPageOptions()}
                  onPageSizeChange={handlePageSizeChange}
                  onPageChange={handlePageChange}
                  showPagination={true}
                  data-testid="pagination-footer"
                />
              ),
              noRowsOverlay: () => (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  No results found
                </Box>
              ),
            }}
            loading={loading}
            slotProps={{
              loadingOverlay: {
                variant: "linear-progress",
                noRowsVariant: "linear-progress",
              },
            }}
            disableColumnMenu
            disableColumnSelector
            disableColumnResize
            onRowSelectionModelChange={handleSelectionChange}
            selectionModel={selectedRows}
            disableRowSelectionOnClick
            data-testid="data-grid"
          />
        </Box>
      </div>
    </div>
  );
};

export default DataGridWithPagination;
